import React, { useContext } from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Collapse from 'antd/lib/collapse';
import { DeclaredComponent } from '../DynamicComponent';
import { PaymentDetailsContext } from '../forms/payment/PaymentDetailsForm';
import {propsToCSS} from '../css';

const Header = ({ header }) => {
    if (!header) return null;

    return <Rows rows={header} />
}

const Columns = ({ columns }) => {
    return columns.map((column, index) => {
        const componentId = Object.keys(column)[0];
        const span = column[componentId].span ? column[componentId].span : '';
        const styleProps = column[componentId].span ? column[componentId].styleProps : null;
        return (
            <Col
                key={index}
                span={span}
                style={styleProps}
            >
                <div>
                    <DeclaredComponent declaration={column} />
                </div>
            </Col>
        )
    })
}

const CollapseRow = ({ plan }) => {
    const { Panel } = Collapse;
    const styles = {
        container: {
            display: 'flex',
            flex: 24
        },
        col: (span) => ({
            flex: span
        })
    }
    const Header = () => {
        return (
            <div style={styles.container}>
                <div style={styles.col(8)}>8</div>
                <div style={styles.col(4)}>4</div>
                <div style={styles.col(4)}>4</div>
                <div style={styles.col(4)}>4</div>
                <div style={styles.col(4)}>4</div>
            </div>
        )
    }
    return (
        <Collapse bordered={false} accordion>
            <Panel header={<Header />}>
                <div style={{width: '100%'}}>
                    Hey there
                </div>
            </Panel>
            <Panel header={
                <div>
                    <p>1</p>
                    <p>2</p>
                    <p>3</p>
                </div>
            }>
                <div>
                    Hey there
                </div>
            </Panel>
        </Collapse>
    )
}

const Rows = ({ rows, collapse }) => {
    if (collapse) {
        const { paymentPlans } = useContext(PaymentDetailsContext);
        return paymentPlans.map((plan, index) => {
            if (index === 0) {
                return (
                    <Row key={index}>
                        <CollapseRow plan={plan} />
                    </Row>
                )
            }
        })
    }

    return rows.map(({ Group }, index) => {
        const columns = Group.content;

        return (
            <Row key={index}>
                <Columns columns={columns} />
            </Row>
        )
    })
}

export const ColumnTable = ({ rows, header, collapse, changeForMobile, hideDivider, ...props }) => {
    if (!rows || !Array.isArray(rows)) return null;

    return (
        <div {...propsToCSS(props)}>
            <Header header={header} />
            {hideDivider === true ? null : (
                <DeclaredComponent declaration={{ Divider: {} }} />
            )}
            <Rows rows={rows} collapse={collapse} />
        </div>
    )
}
